import Vue from 'vue';
import Router from 'vue-router';
import { wxRoute } from './wxRoute';
import { h5Route } from './h5Route';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      redirect: '/student/mili/0/login'
    },
    {
      path: '/common/share',
      name: 'share',
      component: () => import('@/pages/common/share.vue')
    },
    {
      /**
       * 需要登录授权的
       * type: [qupei, org] qupei-米粒家长 org-sass
       * orgid: 机构id
       */
      path: '/student/:type/:orgid',
      name: 'home',
      component: () => import('@/components/layout/base.vue'),
      children: [
        {
          path: '',
          redirect: 'login'
        },
        {
          path: 'login',
          name: 'login',
          meta: { title: '登陆页' },
          component: () => import('@/pages/base/login/index')
        },
        {
          path: 'selectorg',
          name: 'selectorg',
          meta: { title: '登陆页' },
          component: () => import('@/pages/base/select_org/index')
        },
        wxRoute,
        h5Route
      ]
    },
    {
      /**
       * 需要登录授权的
       * orgid: 机构id
       * openid: 微信openid
       * customerid: 客户id
       */
      path: '/order/wx/:orgid/:openid',
      name: 'home',
      component: () => import('@/components/layout/orderAuthority.vue'),
      children: [
        {
          path: '',
          redirect: 'orderList'
        },
        {
          path: 'orderList',
          name: 'orderList',
          meta: { title: '我的订单' },
          component: () => import('@/pages/order/index')
        },
        {
          path: 'confirmOrder/:id/:orderType',
          name: 'confirmOrder',
          meta: { title: '确认订单' },
          component: () => import('@/pages/order/confirm/index')
        },
        {
          path: 'pay/:id/:orderType',
          name: 'pay',
          meta: { title: '确认支付' },
          component: () => import('@/pages/order/pay/index')
        },
        {
          path: 'orderDetail/:orderid',
          name: 'orderDetail',
          meta: { title: '订单详情' },
          component: () => import('@/pages/order/detail/index')
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js